export enum TabKeys {
  VIDEOS = 'videos_tab',
  IMAGES = 'images_tab'
}

export const FETCH_LIMIT = 20
export const CONTEXT_MENU_OFFSET = 3
